import { Platform } from '@jump-tools-front/shared-interfaces';
import { LearnizEnvironment } from '@jump-tools-front/shared';

export const environment: LearnizEnvironment = {
  production: true,
  idleBeforePause: 900,
  mediaPlayerDefaultValidateTime: -5,
  outputRoute: '/error',
  platform: Platform.LEARNIZ,
  isLocal: false,
  domainList: ['storiz-biz.com', 'jump-biz.com', 'parcours.onvaseformer.fr'],
  defaultStyleProperties: {
    primaryColor: '#43AE97',
    darkColor: '#000000',
    lightColor: '#ffffff',
    fontTitle: {
      family: 'Ubuntu',
      ratio: 1,
      letterSpacing: 0,
    },
    landingBackgroundImages: {
      main: {
        type: 'lottie',
        src: 'assets/lotties/LOTTIE_PLANTE.json',
      },
      menu: {
        type: 'lottie',
        src: 'assets/lotties/LOTTIE_VERTEX_01.json',
      },
    },
  },
};
